import { Transition } from "@uirouter/react";
import { MenuNode, MenuRoute } from "../../components/menu";
import { VerificationService } from "../../store/verification/service";
import { LeafRole, Or } from "../../utils/and-or-tree";
import { PageNotFoundRoutes } from "../error/routes";
import { ShellRouteNames } from "../shell/route-names";
import { AllDueDiligence } from "./all";
import { NewDueDiligenceConfigPage } from "./new";
import { SingleDueDiligenceConfigPage } from "./single/private";
import { AdminDueDiligenceForm } from "./single/public/admin";
import { ParticipantDueDiligenceForm } from "./single/public/participant";

const names = {
  single: `${ShellRouteNames.externalShell}.due-diligence-form`,
  participant: `${ShellRouteNames.externalShell}.due-diligence-form-participant`,
};

const merchantNames = {
  new: `${ShellRouteNames.shell}.due-diligence-new`,
  single: `${ShellRouteNames.shell}.due-diligence-single`,
  all: `${ShellRouteNames.shell}.due-diligence-all`,
};

const states: MenuRoute[] = [
  {
    name: names.participant,
    url: "/due-diligence-form",
    views: {
      $default: {
        component: ParticipantDueDiligenceForm,
      },
    },
    data: {
      title: "current-config",
    },
    resolve: [
      {
        token: "id",
        deps: [],
        resolveFn: () => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          return urlSearchParams.get("id");
        },
      },
      {
        token: "code",
        deps: [],
        resolveFn: () => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          return urlSearchParams.get("code");
        },
      },
      {
        token: "item",
        deps: [],
        resolveFn: () => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const id = urlSearchParams.get("id");
          if (id === undefined || id === null) throw new Error("Not Found");
          return VerificationService.getSingleDueDiligenceConfig(id);
        },
      },
    ],
    redirectTo: async (trans: Transition) => {
      try {
        const codeParam = await trans.injector().getAsync("code");
        if (codeParam === null) {
          return await trans.router.stateService.target(
            names.single,
            {},
            { location: false }
          );
        }
        await trans.injector().getAsync("item");
      } catch (err: any) {
        if (err.status === 404) {
          return await trans.router.stateService.target(
            PageNotFoundRoutes.names.pageNotFound,
            {},
            { location: false }
          );
        } else {
          throw err;
        }
      }
    },
  },
  {
    name: names.single,
    url: "/due-diligence-form",
    views: {
      $default: {
        component: AdminDueDiligenceForm,
      },
    },
    data: {
      title: "current-config",
    },
    resolve: [
      {
        token: "configId",
        deps: [],
        resolveFn: () => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          return urlSearchParams.get("id");
        },
      },
      {
        token: "item",
        deps: [],
        resolveFn: () => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const id = urlSearchParams.get("id");
          if (id === undefined || id === null) throw new Error("Not Found");
          return VerificationService.getSingleDueDiligenceConfig(id);
        },
      },
    ],
    redirectTo: async (trans: Transition) => {
      try {
        await trans.injector().getAsync("item");
      } catch (err: any) {
        if (err.status === 404) {
          return await trans.router.stateService.target(
            PageNotFoundRoutes.names.pageNotFound,
            {},
            { location: false }
          );
        } else {
          throw err;
        }
      }
    },
  },
];

const merchantStates: MenuRoute[] = [
  {
    name: merchantNames.new,
    url: "/due-diligence/new",
    views: {
      $default: {
        component: NewDueDiligenceConfigPage,
      },
    },
    data: {
      title: "New B2B Onboarding",
      roles: new Or(new LeafRole("ROLE_MERCHANT"), new LeafRole("ROLE_ADMIN")),
    },
  },
  {
    name: merchantNames.single,
    url: "/due-diligence/:id",
    views: {
      $default: {
        component: SingleDueDiligenceConfigPage,
      },
    },
    data: {
      title: "Update B2B Onboarding Form",
    },
    resolve: [
      {
        token: "id",
        deps: [Transition],
        resolveFn: (t: Transition) => t.params().id,
      },
      {
        token: "item",
        deps: ["id"],
        resolveFn: (id: string) => {
          return VerificationService.getSingleDueDiligenceConfig(id);
        },
      },
    ],
  },
  {
    name: merchantNames.all,
    component: AllDueDiligence,
    url: "/due-diligence",
    data: {
      title: "view-all-b2b-signups",
    },
  },
];

const sidebar: MenuNode.MenuNode = {
  icon: "cryptoToken",
  route: states[0],
  roles: new LeafRole("ROLE_USER"),
};

const merchantSidebar: MenuNode.MenuNode = {
  icon: "cryptoToken",
  title: "Due Diligence",
  children: [
    {
      icon: "cryptoToken",
      route: merchantStates[0],
    },
    {
      icon: "cryptoToken",
      route: merchantStates[2],
    },
    // {
    //   icon: "cryptoToken",
    //   route: merchantStates[1],
    //   roles: [new LeafRole("ROLE_MERCHANT")],
    // },
  ],
  roles: new Or(new LeafRole("ROLE_MERCHANT"), new LeafRole("ROLE_ADMIN")),
};

export const MerchantDueDiligenceRoutes = {
  states: merchantStates,
  names: merchantNames,
  sidebar: merchantSidebar,
};

export const DueDiligenceRoutes = {
  names,
  states,
  sidebar,
};
